<div class="form-group" ngModelGroup="{{ formField.id }}">
    <sb-form-field-label [formField]="formField"></sb-form-field-label>
    <label class="checkbox__label d-block">
        {{ formField.options?.checkboxSideLabel }}
        <input
            type="checkbox"
            name="formField{{ formField.id }}"
            [(ngModel)]="formField.value"
            [required]="formField.isRequired" />
        <span class="checkbox__checkmark"></span>
    </label>

    @if (formService.isSubmitted && !formField.value && formField.isRequired) {
        <div class="text-danger" translate>Please fill this field</div>
    }
</div>
